export const FETCH_CO_OPERATION_REQUEST = "FETCH_CO_OPERATION_REQUEST";
export const UPDATE_CO_OPERATIONS_STATUS_REQUEST = "UPDATE_CO_OPERATIONS_STATUS_REQUEST";
export const CREATE_DOCTOR_FROM_COOPERATIONS = "CREATE_DOCTOR_FROM_COOPERATIONS";
